import React, { PropTypes, Component } from 'react';
import classNames from 'classnames';
import { ContentType } from 'enums';
import Tag from 'common/Tag';
import { contentSubtitle } from '@alias/lib/format';
import playable from '@alias/Playable';

const liStyle = {
    textAlign: 'left',
    position: 'relative'
};

class SuggestionItem extends Component {
    constructor(props) {
        super(props);
        this.handleSuggestionOnClick = this.handleSuggestionOnClick.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { enterPressed, isSelected } = this.props;
        if (nextProps.enterPressed && enterPressed !== nextProps.enterPressed && isSelected) {
            this.handleSuggestionOnClick();
        }
    }

    handleMouseEnter() {
        this.props.handleItemEnter(this.props.index);
    }

    isUserBlackedOut() {
        const { content: { streams = [] } = {} } = this.props;

        // do not label the content as `blackout` unless all the streams are blacked out
        if (streams.length && streams.every(stream => !!stream.blackoutText)) {
            return true;
        }
        return false;
    }

    handleSuggestionOnClick() {
        this.props.handleClick(this.props.content);
        this.props.clickHandler();
    }

// const SuggestionItem = ({ content, handleClick, hideKey, pageType, isSelected }) => {
    render() {
        const { content, pageType, isSelected, handleItemLeave } = this.props;
        const formattedSubtitle = contentSubtitle(content);
        const subtitleEl = formattedSubtitle ? <span>{formattedSubtitle}</span> : null;
        const userIsBlackedOut = this.isUserBlackedOut();

        let status = '';
        let tag;
        let metaDataClass;
        const { type } = content;
        switch (type) {
            case ContentType.LISTING:
                status = content.status;
                tag = <Tag content={content} pageType={pageType} userIsBlackedOut={userIsBlackedOut} />;
                metaDataClass = classNames('collection_item_meta', 'icon-font-before', {
                    'icon-lock-solid-before': content.isLocked
                });
                break;
            case ContentType.TERM:
                break;
            case ContentType.VOD:
                tag = <Tag content={content} pageType={pageType} />;
                break;
            default:
                break;
        }
        const liClass = classNames('search_results__item', { focused: isSelected });

        return (
            <li
                value={content.name}
                type={type}
                data-status={status}
                id={content.id}
                onClick={!userIsBlackedOut && this.handleSuggestionOnClick}
                onMouseEnter={!userIsBlackedOut && this.handleMouseEnter}
                onMouseLeave={!userIsBlackedOut && handleItemLeave}
                className={liClass}
                style={liStyle}
            >
                <div>
                    <a className="search_results__link">
                        <div className="search__results__linkContent">
                            <span className="search_results__keyword">
                                {content.name}
                            </span>
                            <div className={metaDataClass}>
                                <div className="collection_item_truncate">
                                    {subtitleEl}
                                </div>
                            </div>
                        </div>
                        {tag}
                    </a>
                </div>
            </li>
        );
    }
}

SuggestionItem.propTypes = {
    handleClick: PropTypes.func,
    clickHandler: PropTypes.func,
    content: PropTypes.object,
    pageType: PropTypes.string,
    isSelected: PropTypes.bool,
    index: PropTypes.number,
    handleItemEnter: PropTypes.func,
    handleItemLeave: PropTypes.func,
    enterPressed: PropTypes.bool
};

export default playable(SuggestionItem);



// WEBPACK FOOTER //
// ./app/common/search/SuggestionItem.js